export default __webpack_public_path__ + "static/media/calendar.6ccb5ac4.svg";